import { motion } from "framer-motion";
import { ArrowRight, Key } from "@phosphor-icons/react";

const TIERS = [
  { label: "2 BHK Rentals", range: "₹25,000 – ₹40,000 / mo", note: "Aster, Aster NEO, Pratham & more" },
  { label: "3 BHK Rentals", range: "₹35,000 – ₹55,000 / mo", note: "The Meadows, Amogha & more" },
  { label: "4 BHK & Villa Rentals", range: "₹60,000+ / mo", note: "Paarijat, La Marina, North Park" },
];

export default function RentalSection({ onEnquire }) {
  return (
    <section id="rentals" data-testid="rental-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="md:col-span-5"
          >
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-forest/70">
              <Key size={16} weight="duotone" className="text-gold" /> Rentals
            </p>
            <h2 className="mt-4 font-serif text-2xl tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
              Flats for Rent in Shantigram
            </h2>
            <p className="mt-6 text-base leading-relaxed text-slate-600">
              One of Ahmedabad's deepest rental markets — professionals from SG Highway, GIFT City and Gandhinagar
              choose the township for its golf course, lake and gated security. We match tenants with verified owners
              and handle the paperwork.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <button
                data-testid="rental-enquire-btn"
                onClick={() => onEnquire("Rental Enquiry")}
                className="group flex items-center gap-2 rounded-sm bg-forest px-7 py-3.5 text-sm font-bold uppercase tracking-widest text-white transition-colors duration-200 hover:bg-forest-hover"
              >
                Get Rental Listings
                <ArrowRight size={16} weight="bold" className="text-gold transition-transform duration-200 group-hover:translate-x-1" />
              </button>
              <a
                href="/adani-shantigram-rent"
                data-testid="rental-guide-link"
                className="flex items-center gap-2 rounded-sm border border-forest/20 px-7 py-3.5 text-sm font-bold uppercase tracking-widest text-forest transition-colors duration-200 hover:border-gold"
              >
                Rental Guide
              </a>
            </div>
          </motion.div>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-3 md:col-span-7 md:self-center">
            {TIERS.map((t, i) => (
              <motion.div
                key={t.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`rental-tier-${t.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="rounded-lg border border-black/5 bg-cream p-6"
              >
                <p className="text-xs font-semibold uppercase tracking-widest text-slate-500">{t.label}</p>
                <p className="mt-3 font-serif text-lg text-forest">{t.range}</p>
                <p className="mt-2 text-xs text-slate-500">{t.note}</p>
              </motion.div>
            ))}
            <p className="text-xs text-slate-400 sm:col-span-3">
              Indicative ranges — actual rents vary by tower, floor, view and furnishing.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
